import { render, staticRenderFns } from "./storeDetail.vue?vue&type=template&id=94470006&scoped=true&"
import script from "./storeDetail.vue?vue&type=script&lang=js&"
export * from "./storeDetail.vue?vue&type=script&lang=js&"
import style0 from "./storeDetail.vue?vue&type=style&index=0&id=94470006&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94470006",
  null
  
)

export default component.exports